export class SentEmail{
  sendEmailId:number;	
  reciverID:string;  	
  toId:string;  		
  body:string;  	
  date_time:string;  	 
  amount:number;  	 
  createdOn:string;  	 
  updatedOn:string;  		
 user_id:number;
 subject:string;  	
 specification:string;  	
 remark:string;  	
 filePath:string;
 spec:string;
 attachment:string;
 dateTime:string;
 senderId:string;
 sub:string;
}